<template>
  <div>
    <DominioListAddNew
        :is-add-new-dominio-sidebar-active.sync="isAddNewDominioSidebarActive"
        @refetch-data="refetchData"
    />

<!--    &lt;!&ndash; Filters &ndash;&gt;-->
<!--    <DominioListFilters-->
<!--        :status-filter.sync="statusFilter"-->
<!--    />-->

    <!-- Table Container Card -->
    <b-card
        no-body
        class="mb-0"
    >
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Mostrar</label>
            <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
            />
            <label>entradas</label>
          </b-col>

          <!-- Search -->
          <b-col
              cols="12"
              md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  placeholder="Pesquisar..."
              />
              <b-button
                  variant="primary"
                  @click="isAddNewDominioSidebarActive = true"
              >
                <span class="text-nowrap">Novo Dominio</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="fetchDominios"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="Nenhum registro encontrado"
          :sort-desc.sync="isSortDirDesc"
      >
        <template #cell(actions)="data">
          <div>
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="gradient-primary"
                class="btn-icon mr-1"
                :to="{ name: 'apps-dominios-edit', params: { id: data.item.id } }"
            >
              <feather-icon icon="EditIcon" />
            </b-button>

            <b-button
                variant="gradient-danger"
                class="btn-icon"
                @click="showModalDeleteDominio(data.item.id)"
            >
              <feather-icon icon="TrashIcon" />
            </b-button>
          </div>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
                v-model="currentPage"
                :total-rows="totalUsers"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
      <modal-confirmation
          v-model="isDeleteModal"
          id-modal="modal-delete-dominio"
          title="Deletar Dominio"
          message="Tem certeza que deseja deletar?"
          btn-cancel-label="Cancelar"
          btn-ok-label="Sim"
          @ok="removeDominio"
          @cancel="isDeleteModal = false"
      />
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import store from '@/store';
import { ref, onUnmounted } from '@vue/composition-api';
import { avatarText } from '@core/utils/filter';
import Notifier from '@/libs/Notifier';
import ModalConfirmation from '@/components/ModalConfirmation.vue';
import DominioListFilters from './DominioListFilters.vue';
import useDominioList from './useDominioList';
import dominioStoreModule from '../dominioStoreModule';
import DominioListAddNew from './DominioListAddNew.vue';

export default {
  components: {
    ModalConfirmation,
    DominioListFilters,
    DominioListAddNew,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    Notifier,

    vSelect,
  },
  setup() {
    const notify = new Notifier();
    const USER_APP_STORE_MODULE_NAME = 'app-dominio';
    const isDeleteModal = ref(false);
    const idDominio = ref(null);
    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, dominioStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    const isAddNewDominioSidebarActive = ref(false);

    const showModalDeleteDominio = (id) => {
      idDominio.value = id;
      isDeleteModal.value = true;
    };

    const removeDominio = (id) => {
      isDeleteModal.value = false;
      store.dispatch('app-dominio/removeDominio', idDominio.value)
        .then(() => {
          refetchData();
          notify.success('Excluido com sucesso');
        });
    };

    const {
      fetchDominios,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    } = useDominioList();

    return {

      // Sidebar
      isAddNewDominioSidebarActive,
      isDeleteModal,
      idDominio,
      showModalDeleteDominio,
      fetchDominios,
      removeDominio,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select';
</style>
